import gql from 'graphql-tag';

export const addReaction = gql`
  mutation addReaction($source: String!, $contentId: String!, $reaction: String!) {
    addReaction(reaction: { source: $source, contentId: $contentId, reaction: $reaction }) {
      id
      createdAt
      updatedAt
      source
    }
  }
`;

export const removeReaction = gql`
  mutation removeReaction($source: String!, $contentId: String!, $reaction: String!) {
    removeReaction(reaction: { source: $source, contentId: $contentId, reaction: $reaction })
  }
`;

export const getContentsReactions = gql`
  query getContentsReactions($source: String!, $contentsIds: [String!]!) {
    getContentsReactions(params: { source: $source, contentsIds: $contentsIds }) {
      source
      contentId
      reactions {
        count
        reaction
        userReacted
      }
    }
  }
`;

export const getZoomSignature = gql`
  query getZoomSignature($meetingNumber: String!, $role: Int!) {
    zoomSignature(meetingNumber: $meetingNumber, role: $role) {
      signature
    }
  }
`;

export const getLoggedUser = gql`
  query getLoggedUser($descomplicaId: Float!) {
    getLoggedUser(params: { descomplicaId: $descomplicaId }) {
      id
      dexId
      descomplicaId
      firstName
      lastName
      displayName
      accessToken
      avatarUrl
      userSettings {
        shouldAutoPauseVideo
      }
      userInteraction {
        readNoteIntroductionDate
        completedNoteOnboardingDate
      }
      socialMedia {
        email
      }
    }
  }
`;

export const getUserProfilesByDexIds = gql`
  query getUserProfilesByDexIds($dexIds: [Int!]!) {
    getUserProfilesByDexIds(params: { dexIds: $dexIds }) {
      id
      dexId
      descomplicaId
      firstName
      lastName
      displayName
      avatarUrl
    }
  }
`;

export const getUserProfilesByIds = gql`
  query getUserProfilesByIds($profileIds: [Int!]!) {
    getUserProfilesByIds(params: { profileIds: $profileIds }) {
      id
      dexId
      descomplicaId
      firstName
      lastName
      displayName
      avatarUrl
    }
  }
`;

export const getUserMicrocertificates = gql`
  query {
    getUserMicrocertificates {
      id
      profileId
      studentName
      course
      skill
      template {
        id
        name
      }
      emissionDate
      signatureHash
    }
  }
`;

export const getClassroomsByCourseAndPeriod = gql`
  query getMockedClassroomsByCourseAndPeriod($course: String!, $period: Float!) {
    getMockedClassroomsByCourseAndPeriod(course: $course, period: $period) {
      classrooms {
        period
        classroomIds
      }
    }
  }
`;

export const getLoggedUserRecipients = gql`
  query getLoggedUserRecipients(
    $order: String!
    $take: Float!
    $skip: Float!
    $onlyUnseen: Boolean
  ) {
    getLoggedUserRecipients(
      take: $take
      skip: $skip
      order: { id: $order }
      onlyUnseen: $onlyUnseen
    ) {
      id
      email
      viewedAt
      createdAt
      inAppNotification {
        id
        title
        shortDescription
        longDescription
        imageUrl
        icon
        callToActionUrl
        callToActionText
        priority
        campaignName
        campaignVersion
        createdAt
        expiration
      }
    }
  }
`;

export const wsRecipients = gql`
  subscription {
    recipientCreated {
      id
      email
      viewedAt
      createdAt
      inAppNotification {
        id
        title
        shortDescription
        longDescription
        imageUrl
        icon
        callToActionUrl
        callToActionText
        priority
        campaignName
        campaignVersion
        createdAt
        expiration
      }
    }
  }
`;

export const getClassroomsByCourse = gql`
  query getMockedClassroomsByCourse($course: String!) {
    getMockedClassroomsByCourse(course: $course) {
      classrooms
    }
  }
`;

export const getCourses = gql`
  query getMockedCourses {
    getMockedCourses {
      courses
    }
  }
`;

export const filterClassroomsByPeriod = gql`
  query filterClassroomsByPeriod($course: String!, $classroomsIds: [Float!]!) {
    filterClassroomsByPeriod(course: $course, classroomsIds: $classroomsIds) {
      data {
        period
        classrooms {
          id
          name
          type
        }
      }
    }
  }
`;

export const getBoardsGroupsByCourseIdQuery = gql`
  query getBoardsGroupsByCourseId($courseId: Int!) {
    getBoardsGroupsByCourseId(courseId: $courseId) {
      id
      name
      description
      courseId
      groups {
        id
        name
        description
        boardsGroupId
        boardIds
        position
      }
    }
  }
`;

export const getBlocklist = gql`
  query {
    getBlocklist(platform: classrooms) {
      data {
        id
        url
        platform
        expiration
      }
      pageNumber
      totalPages
      pageSize
      totalEntries
    }
  }
`;

export const getNotesByVideoId = gql`
  query getNotesByVideoId($videoId: String!, $deletedAt: DateTime) {
    getNotesUndergrad(videoId: $videoId, deletedAt: $deletedAt) {
      data {
        id
        profileId
        videoId
        lessonId
        disciplineId
        originUrl
        platform
        videoTimeStamp
        latestText {
          id
          markdownText
        }
        draft {
          id
          markdownText
        }
      }
      pageNumber
      totalPages
      pageSize
      totalEntries
    }
  }
`;

export const getCurrentPeriodStartDate = gql`
  query getCurrentPeriodStartDate {
    getCurrentPeriodStartDate {
      startDate
    }
  }
`;

export const getTrialStartDate = gql`
  query getTrialStartDate($userId: Int) {
    result: getTrialStartDate(userId: $userId) {
      currentServerDate
      trialStartDate
      trialEndDate
      trialActive
    }
  }
`;

export const getAllUserNotesUndergrad = gql`
  query getAllUserNotesUndergrad($disciplineId: String) {
    getAllUserNotesUndergrad(disciplineId: $disciplineId, deletedAt: null) {
      data {
        discipline
        lessons {
          lesson
          videos {
            video
            notes {
              id
              video
              lesson
              disciplineId
              discipline
              videoTimeStamp
              originUrl
              latestText {
                markdownText
              }
            }
          }
        }
        totalNotes
      }
    }
  }
`;

export const getSharedNotebookByHash = gql`
  query getSharedNotebook($generatedLink: String) {
    getSharedNotebook(generatedLink: $generatedLink) {
      id
      profileId
      disciplineId
      generatedLink
      createdAt
    }
  }
`;

export const getUndergradStudyPlanQuery = gql`
  query getUndergradStudyPlanQuery {
    getStudentStudyPlanTemplate {
      id
      name
      courseId
      moduleId
      eventId
      activities {
        id
        pedagogicalActivityId
        week
        courseId
        disciplineId
        moduleId
        playlistId
        startDateTime
      }
    }
  }
`;

export const getClassNotesByVideoId = gql`
  query getClassNotesByVideoId($videoId: Int!, $onlyPrivateNotes: Boolean) {
    getClassNotesUndergrad(videoId: $videoId, onlyPrivate: $onlyPrivateNotes) {
      data {
        id
        profileId
        videoId
        lessonId
        disciplineId
        originUrl
        platform
        videoTimeStamp
        latestText {
          id
          markdownText
        }
        draft {
          id
          markdownText
        }
        noteSettings {
          id
          isPrivate
        }
      }
      pageNumber
      totalPages
      pageSize
      totalEntries
    }
  }
`;
